document.addEventListener('DOMContentLoaded', () => {
  const videoContainer = document.querySelector('[data-compatibility-video-container]');
  if (!videoContainer) return;

  const videos = videoContainer.querySelectorAll('video[data-platform]');
  const playButton = videoContainer.querySelector('[data-play-button]');
  const expandButton = videoContainer.querySelector('[data-expand-button]');
  const toggleButtons = document.querySelectorAll('[data-platform-toggle]');

  if (!videos.length) return;

  let activePlatform = 'ios';

  const getActiveVideo = () => videoContainer.querySelector(`video[data-platform="${activePlatform}"]`);

  const showPlayButton = () => {
    playButton?.classList.remove('hidden');
  };

  const hidePlayButton = () => {
    playButton?.classList.add('hidden');
  };

  const switchPlatform = (platform) => {
    if (platform === activePlatform) return;

    const currentVideo = getActiveVideo();
    if (currentVideo && !currentVideo.paused) {
      currentVideo.pause();
      currentVideo.currentTime = 0;
    }

    for (const video of videos) {
      if (video.dataset.platform === platform) {
        video.classList.remove('hidden');
      } else {
        video.classList.add('hidden');
      }
    }

    activePlatform = platform;
    showPlayButton();
  };

  const togglePlayPause = () => {
    const video = getActiveVideo();
    if (!video) return;

    if (video.paused) {
      video.play().catch(() => { });
    } else {
      video.pause();
    }
  };

  for (const btn of toggleButtons) {
    btn.addEventListener('click', () => {
      const platform = btn.dataset.platformToggle;
      switchPlatform(platform);
    });
  }

  if (playButton) {
    playButton.addEventListener('click', togglePlayPause);
  }

  const enterFullscreen = (video) => {
    const request = video.requestFullscreen
      ?? video.webkitRequestFullscreen
      ?? video.webkitEnterFullscreen
      ?? video.msRequestFullscreen;

    if (!request) return;

    const result = request.call(video);
    if (result?.then) {
      result.then(() => video.play().catch(() => { })).catch(() => { });
      return;
    }
    video.play().catch(() => { });
  };

  if (expandButton) {
    expandButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const video = getActiveVideo();
      if (video) enterFullscreen(video);
    });
  }

  const handleFullscreenExit = () => {
    if (document.fullscreenElement || document.webkitFullscreenElement) return;
    const video = getActiveVideo();
    if (video && !video.paused) video.pause();
  };

  document.addEventListener('fullscreenchange', handleFullscreenExit);
  document.addEventListener('webkitfullscreenchange', handleFullscreenExit);

  for (const video of videos) {
    video.addEventListener('click', togglePlayPause);

    video.addEventListener('play', () => {
      hidePlayButton();
    });

    video.addEventListener('pause', () => {
      showPlayButton();
    });
  }

  if ('IntersectionObserver' in window) {
    const scrollObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) {
            const activeVideo = getActiveVideo();
            if (activeVideo && !activeVideo.paused) {
              activeVideo.pause();
            }
          }
        }
      },
      { threshold: 0.3 }
    );

    scrollObserver.observe(videoContainer);
  }
});
